import React from 'react';
import { Link } from 'react-router-dom';

const WiziTalkPreviewSection: React.FC = () => {
  return (
    <div className="container-fluid py-5">
      <div className="container py-5">
        <div className="row g-5 align-items-center">
          <div className="col-lg-6 wow fadeInRight" data-wow-delay="0.1s">
            <div className="position-relative">
              {/* Voice Assistant Interface Mockup */}
              <div className="bg-white rounded-4 shadow-lg p-4 position-relative overflow-hidden">
                {/* Header */}
                <div className="d-flex align-items-center justify-content-between mb-4 pb-3 border-bottom">
                  <div className="d-flex align-items-center">
                    <div className="bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3" 
                         style={{ width: '50px', height: '50px' }}>
                      <i className="fas fa-microphone text-white fs-4"></i>
                    </div>
                    <div>
                      <h6 className="mb-0">WiziTalk Assistant</h6>
                      <small className="text-success">
                        <i className="fas fa-circle me-1" style={{ fontSize: '8px' }}></i>
                        Active & Listening
                      </small>
                    </div>
                  </div>
                  <div className="bg-success bg-opacity-10 rounded-3 px-3 py-1">
                    <small className="text-white fw-bold">
                      <i className="fas fa-volume-up me-1"></i>Voice Mode
                    </small>
                  </div>
                </div>

                {/* Conversation Messages */}
                <div className="mb-4">
                  {/* Student Message */}
                  <div className="d-flex mb-3">
                    <div className="bg-primary bg-opacity-10 rounded-3 px-3 py-2 ms-auto" style={{ maxWidth: '80%' }}>
                      <small className="text-muted d-block mb-1">
                        <i className="fas fa-user me-1"></i>You asked:
                      </small>
                      <p className="mb-0 text-dark">"Can you explain the concept of electromagnetic induction?"</p>
                    </div>
                  </div>

                  {/* AI Response */}
                  <div className="d-flex mb-3">
                    <div className="bg-light rounded-3 px-3 py-2 me-auto" style={{ maxWidth: '85%' }}>
                      <small className="text-muted d-block mb-1">
                        <i className="fas fa-robot me-1"></i>WiziTalk explained:
                      </small>
                      <p className="mb-2 text-dark">
                        "Electromagnetic induction is when a changing magnetic field creates an electric current. 
                        Think of it like this - when you move a magnet near a coil of wire, it generates electricity!"
                      </p>
                      <div className="d-flex align-items-center">
                        <small className="text-success me-2">
                          <i className="fas fa-volume-up me-1"></i>Audio explanation played
                        </small>
                        <small className="text-muted">2:34 duration</small>
                      </div>
                    </div>
                  </div>

                  {/* Follow-up Question */}
                  <div className="d-flex mb-3">
                    <div className="bg-primary bg-opacity-10 rounded-3 px-3 py-2 ms-auto" style={{ maxWidth: '75%' }}>
                      <small className="text-muted d-block mb-1">
                        <i className="fas fa-user me-1"></i>Follow-up:
                      </small>
                      <p className="mb-0 text-dark">"Can you give me a real-world example?"</p>
                    </div>
                  </div>

                  {/* AI Follow-up Response */}
                  <div className="d-flex">
                    <div className="bg-light rounded-3 px-3 py-2 me-auto" style={{ maxWidth: '85%' }}>
                      <small className="text-muted d-block mb-1">
                        <i className="fas fa-robot me-1"></i>WiziTalk example:
                      </small>
                      <p className="mb-2 text-dark">
                        "Sure! Electric generators work on this principle. When you pedal a bicycle with a dynamo, 
                        the rotating magnet creates electricity to power your bike lights!"
                      </p>
                      <div className="bg-success bg-opacity-10 rounded-2 px-2 py-1 d-inline-block">
                        <small className="text-white">
                          <i className="fas fa-lightbulb me-1"></i>Concept understood!
                        </small>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Voice Input Area */}
                <div className="bg-light rounded-3 p-3 position-relative">
                  <div className="d-flex align-items-center justify-content-center">
                    <div className="position-relative">
                      <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center" 
                           style={{ width: '60px', height: '60px' }}>
                        <i className="fas fa-microphone text-white fs-4"></i>
                      </div>
                      {/* Animated rings */}
                      <div className="position-absolute top-50 start-50 translate-middle border border-primary rounded-circle opacity-50" 
                           style={{ width: '80px', height: '80px', animation: 'pulse 2s infinite' }}></div>
                      <div className="position-absolute top-50 start-50 translate-middle border border-primary rounded-circle opacity-25" 
                           style={{ width: '100px', height: '100px', animation: 'pulse 2s infinite 0.5s' }}></div>
                    </div>
                  </div>
                  <div className="text-center mt-3">
                    <small className="text-primary fw-bold">
                      <i className="fas fa-waveform me-1"></i>Listening... Ask your next question
                    </small>
                    <div className="mt-2">
                      <small className="text-muted">Supports English & Hindi • Voice & Text</small>
                    </div>
                  </div>
                </div>

                {/* Quick Actions */}
                <div className="mt-3 d-flex justify-content-center gap-2">
                  <div className="bg-primary bg-opacity-10 rounded-pill px-3 py-1">
                    <small className="text-white">📝 Take Notes</small>
                  </div>
                  <div className="bg-success bg-opacity-10 rounded-pill px-3 py-1">
                    <small className="text-white">🔄 Repeat</small>
                  </div>
                  <div className="bg-warning bg-opacity-10 rounded-pill px-3 py-1">
                    <small className="text-white">💡 More Examples</small>
                  </div>
                </div>

                {/* Floating Sound Waves */}
                <div className="position-absolute top-0 end-0 translate-middle">
                  <div className="text-primary opacity-50">
                    <i className="fas fa-wave-square fa-2x"></i>
                  </div>
                </div>
              </div>
              
              {/* Background decorative elements */}
              <div className="position-absolute top-0 start-0 translate-middle opacity-25">
                <div className="bg-success rounded-circle" style={{ width: '40px', height: '40px' }}></div>
              </div>
              <div className="position-absolute bottom-0 end-0 translate-middle opacity-25">
                <div className="bg-primary rounded-circle" style={{ width: '25px', height: '25px' }}></div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 wow fadeInLeft" data-wow-delay="0.3s">
            <div className="h-100">
              <h4 className="text-primary mb-3">WiziTalk AI Assistant</h4>
              <h1 className="display-4 mb-4">
                Talk to Your <span className="wiziai-gradient-text">Tutor, Anytime</span>
              </h1>
              <p className="mb-4 fs-5">
                Meet WiziTalk, your 24/7 AI learning companion that listens to your questions and explains 
                complex concepts in simple, conversational language. Just speak naturally, and get instant, 
                personalized explanations that adapt to your learning style.
              </p>
              
              <div className="row g-4 mb-4">
                <div className="col-md-6">
                  <div className="d-flex align-items-center">
                    <span className="fas fa-comments fa-2x me-3 text-primary"></span>
                    <div>
                      <h6 className="mb-1">Natural Conversations</h6>
                      <small className="text-muted">Speak or type naturally</small>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="d-flex align-items-center">
                    <span className="fas fa-clock fa-2x me-3 text-primary"></span>
                    <div>
                      <h6 className="mb-1">24/7 Availability</h6>
                      <small className="text-muted">Always ready to help</small>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="d-flex align-items-center">
                    <span className="fas fa-language fa-2x me-3 text-primary"></span>
                    <div>
                      <h6 className="mb-1">Multi-Language</h6>
                      <small className="text-muted">English & Hindi support</small>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="d-flex align-items-center">
                    <span className="fas fa-brain fa-2x me-3 text-primary"></span>
                    <div>
                      <h6 className="mb-1">Adaptive Learning</h6>
                      <small className="text-muted">Personalized explanations</small>
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-dark mb-4">
                <p className="fs-5">
                  <span className="fa fa-check text-primary me-2"></span>
                  Voice recognition with instant doubt resolution
                </p>
                <p className="fs-5">
                  <span className="fa fa-check text-primary me-2"></span>
                  Follow-up questions and deeper concept exploration
                </p>
                <p className="fs-5">
                  <span className="fa fa-check text-primary me-2"></span>
                  Real-world examples and visual explanations
                </p>
                <p className="fs-5">
                  <span className="fa fa-check text-primary me-2"></span>
                  Save conversations and create study notes automatically
                </p>
              </div>

              <div className="d-flex flex-column flex-md-row gap-3">
                <Link to="/wizitalk" className="btn btn-primary btn-lg px-4 py-3">
                  <i className="fas fa-microphone me-2"></i>Try WiziTalk Now
                </Link>
                <Link to="/demo/voice" className="btn btn-outline-primary btn-lg px-4 py-3">
                  <i className="fas fa-play me-2"></i>Watch Voice Demo
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WiziTalkPreviewSection;
